import UserSignin from "app/user/sign-in";
import Balance from "app/balances/balance";
import ForgotPwd from "./user/forgot-password";
import ResetPwd from "./user/reset-password";
import PostP2POrder from "./p2p/fx/orders/new";
import P2POrders from "./p2p/fx/orders";
import MyP2POrders from "./p2p/fx/user/orders";
import P2POrder from "./p2p/fx/user/orders/view";
import UserSignUp from "./user/sign-up";
import CreateBeneficiary from "./beneficiaries/create";
import CreatePayout from "./transfers/payout";
import VCard from "./cards/view";
import CreateTransferPayout from "./transfers/payout_internal";
import ResetPin from "./user/reset-pin";
import CreateSwap from "./swaps";
import DwOffers from "./p2p/ewallets";
import CreateOffer from "./p2p/ewallets/create";
import UserOffers from "./p2p/ewallets/user/offers";
import UserOffer from "./p2p/ewallets/user/offers/view";
import UserSwaps from "./p2p/ewallets/user/swaps";
import UserSwap from "./p2p/ewallets/user/swaps/view";
import OrderGiftCard from "./gift_cards/buy";
import PerfectMoneySell from "./switch/perfect_money/sell";
import PerfectMoneyBuy from "./switch/perfect_money/buy";
import PayPalBuy from "./switch/paypal/buy";
import PayPalSell from "./switch/paypal/sell";
import PerfectMoney from "./switch/perfect_money";
import PayPal from "./switch/paypal";
import Payeer from "./switch/payeer";
import PayeerBuy from "./switch/payeer/buy";
import PayeerSell from "./switch/payeer/sell";
import RequestMoneyIndex from "./switch/request_money/requestMoney";
import SwitchTransaction from "./switch/view";
import P2PTransactions from "./p2p/ewallets/user/transactions";
import P2PTransaction from "./p2p/ewallets/user/transactions/view";

const appRoutes = [
  {
    name: "Sign In",
    key: "sign-in",
    route: "/sign-in",
    component: <UserSignin />,
    secure: false,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up",
    component: <UserSignUp />,
    secure: false,
  },
  {
    name: "Forgot Password",
    key: "forgot-password",
    route: "/forgot-password",
    component: <ForgotPwd />,
    secure: false,
  },
  {
    name: "Reset Password",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPwd />,
    secure: false,
  },
  {
    name: "Reset Pin",
    key: "reset-pin",
    route: "/reset-pin",
    component: <ResetPin />,
    secure: false,
  },
  {
    name: "Balance",
    key: "balance",
    route: "/balances/:currency",
    component: <Balance />,
    secure: true,
  },
  {
    name: "Virtual Card",
    key: "card",
    route: "/cards/:reference",
    component: <VCard />,
    secure: true,
  },
  // {
  //   key: "bank-account",
  //   route: "/bank-accounts/:reference",
  //   component: <Balance />,
  //   secure: true,
  // },
  {
    name: "New Beneficiary",
    key: "beneficiaries-create",
    route: "/beneficiaries/create",
    component: <CreateBeneficiary />,
    secure: true,
  },
  {
    name: "Bank Transfer",
    key: "payout-create",
    route: "/transfers/create",
    component: <CreatePayout />,
    secure: true,
  },
  {
    name: "Instant Transfer",
    key: "payout-create-alero",
    route: "/transfers/transfer",
    component: <CreateTransferPayout />,
    secure: true,
  },
  {
    name: "Currency Swap",
    key: "currency-convert",
    route: "/convert",
    component: <CreateSwap />,
    secure: true,
  },
  {
    name: "P2P FX Market",
    key: "p2p-fx-market",
    route: "/p2p/fx",
    component: <P2POrders />,
    secure: true,
  },
  {
    name: "New P2P Order",
    key: "p2p-post-order",
    route: "/p2p/fx/post",
    component: <PostP2POrder />,
    secure: true,
  },
  {
    name: "My P2P orders",
    key: "p2p-user-orders",
    route: "/p2p/fx/my-orders",
    component: <MyP2POrders />,
    secure: true,
  },
  {
    name: "P2P order",
    key: "p2p-user-order",
    route: "/p2p/fx/my-orders/:reference",
    component: <P2POrder />,
    secure: true,
  },
  {
    name: "P2P Digital Wallets",
    key: "p2p-ewallet-market",
    route: "/p2p/ewallets",
    component: <DwOffers />,
    secure: true,
  },
  {
    name: "New Request",
    key: "ewallet-request-post",
    route: "/p2p/ewallets/create",
    component: <CreateOffer />,
    secure: true,
  },
  {
    name: "My Requests",
    key: "p2p-user-requests",
    route: "/p2p/ewallets/my-requests",
    component: <UserOffers />,
    secure: true,
  },
  {
    name: "Offer",
    key: "p2p-user-offer",
    route: "/p2p/ewallets/my-requests/:reference",
    component: <UserOffer />,
    secure: true,
  },
  {
    name: "My Swaps",
    key: "p2p-user-swaps",
    route: "/p2p/ewallets/history",
    component: <UserSwaps />,
    secure: true,
  },
  {
    name: "Swap Transaction",
    key: "p2p-user-swap",
    route: "/p2p/ewallets/history/:reference",
    component: <UserSwap />,
    secure: true,
  },
  {
    name: "My Transactions",
    key: "p2p-user-transactions",
    route: "/p2p/ewallets/transactions",
    component: <P2PTransactions />,
    secure: true,
  },
  {
    name: "Transaction",
    key: "p2p-user-transaction",
    route: "/p2p/ewallets/transactions/:reference",
    component: <P2PTransaction />,
    secure: true,
  },
  {
    name: "Buy Gift Card",
    key: "giftcard-buy",
    route: "/giftcards/:reference",
    component: <OrderGiftCard />,
    secure: true,
  },
  {
    name: "Perfect Money",
    key: "pm",
    route: "/pm",
    component: <PerfectMoney />,
    secure: true,
  },
  {
    name: "Buy Perfect Money",
    key: "pm-buy",
    route: "/pm/buy",
    component: <PerfectMoneyBuy />,
    secure: true,
  },
  {
    name: "Sell Perfect Money",
    key: "pm-sell",
    route: "/pm/sell",
    component: <PerfectMoneySell />,
    secure: true,
  },
  {
    name: "PayPal",
    key: "paypal",
    route: "/paypal",
    component: <PayPal />,
    secure: true,
  },
  {
    name: "Buy PayPal",
    key: "paypal-buy",
    route: "/paypal/buy",
    component: <PayPalBuy />,
    secure: true,
  },
  {
    name: "Sell PayPal",
    key: "paypal-sell",
    route: "/paypal/sell",
    component: <PayPalSell />,
    secure: true,
  },
  {
    name: "Payeer",
    key: "payeer",
    route: "/payeer",
    component: <Payeer />,
    secure: true,
  },
  {
    name: "Buy Payeer",
    key: "payeer-buy",
    route: "/payeer/buy",
    component: <PayeerBuy />,
    secure: true,
  },
  {
    name: "Sell Payeer",
    key: "payeer-sell",
    route: "/payeer/sell",
    component: <PayeerSell />,
    secure: true,
  },
  {
    name: "Request Money",
    key: "switch-request-money",
    route: "/switch/request-money",
    component: <RequestMoneyIndex />,
    secure: true,
  },
  {
    name: "Switch Transaction",
    key: "switch-transaction",
    route: "/switch/:reference",
    component: <SwitchTransaction />,
    secure: true,
  },
];

export default appRoutes;
